import { useState } from 'react';
import { faqItems } from '../../../mocks/home';

export default function FAQ() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section id="faq" className="py-28" style={{ background: 'transparent' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span
            className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold mb-4"
            style={{ background: 'var(--badge-bg)', color: 'var(--gold-hover)', fontFamily: "'DM Sans', sans-serif", border: '1px solid rgba(200,131,42,0.15)' }}
          >
            Dúvidas frequentes
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ color: 'var(--heading-ink)', fontFamily: "'DM Sans', sans-serif", fontWeight: 800, letterSpacing: '-0.03em' }}
          >
            Perguntas &amp; Respostas
          </h2>
          <p
            className="text-base max-w-md mx-auto"
            style={{ color: 'var(--text-strong)', fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
          >
            Tudo que você precisa saber antes de criar a sua música personalizada.
          </p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-2.5">
          {faqItems.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className="glass home-card rounded-2xl overflow-hidden transition-all duration-200"
                style={{
                  border: `1px solid ${isOpen ? 'rgba(200,131,42,0.30)' : 'rgba(0,0,0,0.07)'}`,
                  backdropFilter: 'blur(18px)',
                  WebkitBackdropFilter: 'blur(18px)',
                  boxShadow: isOpen ? '0 4px 20px rgba(200,131,42,0.07)' : '0 1px 4px rgba(0,0,0,0.03)',
                }}
              >
                <button
                  onClick={() => setOpenId(isOpen ? null : item.id)}
                  className="w-full flex items-center justify-between px-6 py-5 cursor-pointer text-left"
                >
                  <span
                    className="font-medium text-base pr-4"
                    style={{ color: 'var(--heading-ink)', fontFamily: "'DM Sans', sans-serif" }}
                  >
                    {item.question}
                  </span>
                  <div
                    className="w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300"
                    style={{
                      background: isOpen ? 'var(--gold)' : 'rgba(0,0,0,0.06)',
                      transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
                    }}
                  >
                    <i
                      className="ri-add-line text-sm"
                      style={{ color: isOpen ? '#fff' : 'var(--text-strong)' }}
                    />
                  </div>
                </button>

                {isOpen && (
                  <div className="px-6 pb-5">
                    <p
                      className="text-sm leading-relaxed"
                      style={{ color: 'var(--text-strong)', fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
                    >
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
